import { Component, ElementRef, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { VariablesProvider } from '../../providers/variables/variables';
import { FuncionesProvider } from '../../providers/funciones/funciones';
import { CalendarModal, CalendarModalOptions, DayConfig, CalendarResult } from "ion2-calendar";
import { CalendarComponentOptions } from 'ion2-calendar'
import { Storage } from '@ionic/storage';
import { ListPage } from '../../pages/list/list';
/**
 * Generated class for the MapasPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
declare var google;

@IonicPage()
@Component({
  selector: 'page-mapas',
  templateUrl: 'mapas.html',
})
export class MapasPage {

  @ViewChild('map') mapElement: ElementRef;


  rs_picajes;
  rs_xls;
  neighborhoods;

  markers = [];
  
  map;
  map2;
  popup;
  Popup;
  mapaListo = false;
  inicializandoMapa = false;

  optionsRange: CalendarModalOptions = {
    color:'dark',
    weekStart:1,
    defaultDate: this.variables.DIA,
    weekdays:['DO', 'LU', 'MA', 'MI', 'JU', 'VI', 'SA'],
    canBackwardsSelected: true,
     daysConfig: [{
      date: new Date(this.variables.DIA),
      subTitle: '',
      disable: false,
      cssClass: 'dayOff'
    }]
  };

  constructor(
    private storage: Storage,    
    public funciones:FuncionesProvider,
    public variables:VariablesProvider,
    public navCtrl: NavController, 
    public navParams: NavParams
    ) 
  {
  
   this.variables.VERMAPA = "si";  

   if (this.variables.DIA) { 
       // code...
     } else {
       var f = new Date();
       this.variables.DIA =  f.getFullYear() + "-" + ("0" + (f.getMonth() + 1)).slice(-2) + "-" +("0" + (f.getDate())).slice(-2) ;

     }


  }

  ionViewDidLoad() {

      // If you're adding a number of markers, you may want to drop them on the map
      // consecutively rather than all at once. This example shows how to use
      // window.setTimeout() to space your markers' animation.


    console.clear();
    this.initMap();
    //console.log("usuario mapa:" + this.variables.usuariomapa);

     }


    
     initMap() 
      {
        if (this.mapaListo && this.map) {
          return;
        }

        if (this.inicializandoMapa) {
          return;
        }

        var contenedor = this.mapElement && this.mapElement.nativeElement;
        if (!contenedor || !(contenedor instanceof HTMLElement)) {
          setTimeout(() => this.initMap(), 50);
          return;
        }

        if (typeof google === 'undefined' || !google.maps || !google.maps.Map) {
          setTimeout(() => this.initMap(), 100);
          return;
        }

        this.inicializandoMapa = true;
        try {
          this.map = new google.maps.Map(contenedor, {
            zoom: 5.2,
            center: {lat:37.630, lng: -4.14}
          });
          this.mapaListo = true;
          this.drop();
        } catch (error) {
          console.error('No se pudo inicializar el mapa', error);
          this.map = null;
          this.mapaListo = false;
          setTimeout(() => this.initMap(), 250);
        } finally {
          this.inicializandoMapa = false;
        }

      }

     
      addMarker(lat,lng,i) {

        if (!this.mapaListo || !this.map) {
          return;
        }

        if (this.variables.usuariomapa=="todos"){

        }else{
          this.map.setZoom(15);
          this.map.setCenter({lat:Number(lat), lng: Number(lng)});
  
        }
  

  
        var ventana;
        var coordenadas = new google.maps.LatLng(lat,lng);
    
        var marcador = new google.maps.Marker({
            position: coordenadas,
            map: this.map,
            title: this.rs_picajes[i].NOMBRE,
            icon: 'https://www.panel-control.com/picademo/recursos/imgs/person.png'
        });

        this.markers.push(marcador);
        
        var cadena='<div>'+'<p class="codigo">'+this.rs_picajes[i].CODIGO+'</p>';
        cadena= cadena +'<P class="nombre">' + this.rs_picajes[i].NOMBRE +'</P>';
        cadena= cadena +'<TABLE><TR>';
        cadena= cadena +'<TD><p>Día: ' + this.rs_picajes[i].FECHA + ' Hora:' + this.rs_picajes[i].HORA +'</p>';
        cadena= cadena +'<p>Obra:'+ this.rs_picajes[i].OBRA +'</p>';
        cadena= cadena +'<p>'+ "Lat:" + lat + "Lng:" + lng +  '</p>';
        cadena=cadena+'</TD></TR></TABLE></div>';
        google.maps.event.addListener(marcador, 'click', function() {
         if (ventana) ventana.close();
          ventana = new google.maps.InfoWindow({content: cadena});
          ventana.open(this.map,marcador);          
        }); 

      }

     
      clearMarkers() {
        for (var i = 0; i < this.markers.length; i++) {
          this.markers[i].setMap(null);
        }
        this.markers = [];
      }
      

  onChange($event) {

    this.variables.DIA  = $event;
    
    
    this.storage.set('DIASELECIONADO', this.variables.DIA );
    
    this.drop();
  
    

  }

  drop() {

      if (!this.mapaListo || !this.map) {
        return;
      }

      this.clearMarkers();

        //console.log("Busca los picajes del día:" + this.variables.DIA );

        this.funciones.obtienepicajesglobal(this.variables.DIA).then(
          data => {



          this.rs_picajes = data
          var horainicio=0;
          var minutoinicio=0;
          var minutosdelahora=0;
          var inicioreal = 0;
          var d = new Date();
          
          this.rs_xls = [];

          var lug;
          var lat;
          var lng;
          var Local;
          var hacer="si";
        
          


          



          for (var _i = 0; _i < this.rs_picajes.length; _i++) {

            
                 

             if (this.variables.usuariomapa!="todos"){

                hacer="no";

                //console.log("ES:" + this.variables.usuariomapaid);


                if (this.variables.usuariomapa == this.rs_picajes[_i].CODIGO || this.variables.usuariomapaid == this.rs_picajes[_i].ID ){
                  hacer="si";
                }

            }else{

              this.variables.usuariomapaid="";

              hacer="si";
            }
            
     

            if (hacer=="si") {


                lug = this.rs_picajes[_i].LOCALIZACION.indexOf("-");
                  

                if (lug <= 0){
                  
                  lug = this.rs_picajes[_i].LOCALIZACION.indexOf(".");
                  if (lug > 0){
                  var stri = this.rs_picajes[_i].LOCALIZACION.substr(lug + 1);
                  lug = lug + stri.indexOf(".");
                  
                  }else{

                  }


                }

                if (lug > 0){

                this.addMarker( this.rs_picajes[_i].LOCALIZACION.substr(0, lug),this.rs_picajes[_i].LOCALIZACION.substr(lug) ,_i);

                }
              

            }

          }
     

          
      
          
      });
      
      }


salir(){
  this.navCtrl.push(ListPage).then(() => {
 
  this.navCtrl.remove(this.navCtrl.getPrevious().index);
});
  

}



}



// WEBPACK FOOTER //
// ./src/pages/mapas/mapas.ts